<adl-table
  (configChange)="setConfig($event)"
  (buttonClick)="onActionHandler($event)"
  [loading]="isLoading"
  [tableData]="programHistory"
  [columnHeader]="columnHeader"
  [counter]="false"
  [paginationInfo]="programHistoryPaginated"
></adl-table>
<app-order-detail-modal></app-order-detail-modal>
